import React from 'react';

import { Grid } from '@mui/material';

export const AddressFieldsWrapper: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Grid container spacing={2}>
    {children}
  </Grid>
);
